import React from "react";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import InquiryForm from "@/components/InquiryForm";

const ContactPage = () => {
  return (
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10" data-testid="contact-page">
      <div className="overline mb-4">Contact</div>
      <h1 className="font-display text-5xl font-black tracking-tight text-ink md:text-6xl">
        Let&apos;s talk.
      </h1>
      <p className="mt-4 max-w-2xl text-muted-warm">
        Product questions, pricing, service, or anything else — send us a
        message and our team will get back to you.
      </p>

      <div className="mt-16 grid gap-12 md:grid-cols-[1fr,1.4fr]">
        <div className="space-y-6" data-testid="contact-info-block">
          {[
            { icon: MapPin, label: "Head Office", value: "Biratnagar, Nepal" },
            { icon: Phone, label: "Phone", value: "+977-9820755721" },
            { icon: Mail, label: "Email", value: "arelnepal@gmail.com" },
            { icon: Clock, label: "Hours", value: "Sun–Fri · 10:00 – 18:00" },
          ].map((c, i) => (
            <div key={i} className="arel-card flex items-start gap-4 rounded-xl p-5">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-md bg-[#dd0447]/10 text-[#dd0447]">
                <c.icon className="h-5 w-5" />
              </div>
              <div>
                <div className="overline">{c.label}</div>
                <div className="mt-1 text-base font-semibold text-ink">{c.value}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="arel-card rounded-2xl p-8">
          <div className="mb-6 font-display text-2xl font-bold text-ink">Send us a message</div>
          <InquiryForm
            inquiryType="contact"
            testIdPrefix="contact"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
